import { css, SerializedStyles } from '@emotion/react';

export const forgotPasswordStyles: { [key: string]: SerializedStyles } = {
  panel: css`
    margin: 40px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    max-width: 320px;
    min-width: 280px;

    @media (min-width: 600px) {
      margin: 12% auto;
    }
  `,
  logoXomThom: css`
    width: 90%;
  `,
};
